import { render } from "./CIS-Image-Carousel-Item.vue?vue&type=template&id=759c8b8c&scoped=true"
import script from "./CIS-Image-Carousel-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Image-Carousel-Item.vue?vue&type=script&lang=js"

import "./CIS-Image-Carousel-Item.vue?vue&type=style&index=0&id=759c8b8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759c8b8c"]])

export default __exports__